/**
 * Strip runtime-only / legacy fields before persisting editor objects to storage.
 */

export const stripDocumentForStorage = (document) => ({
  name: document?.name || "",
  subject: document?.subject || "",
  updatedAt: document?.updatedAt || new Date().toISOString(),
  layout: document?.layout,
});

export const stripLayoutBlockForStorage = (name, grid) => ({
  name: name?.trim() || "Layout",
  grid,
});

export const stripComponentForStorage = (payload) => ({
  name: payload?.name?.trim() || "Componente",
  componentKey: payload.componentKey,
  props: payload?.props || {},
});
 